<template>
  <div class="container">
    <transition name="slide" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>
<script>
export default {
  created() {
    this.$store.dispatch('getUser').catch(() => {
      this.$router.push({ name: 'login' });
    });
  }
};
</script>

<style>
.container {
  min-height: calc(100vh - 70px);
}

.slide-enter-active {
  animation: slide-in 100ms ease-in forwards;
}
.slide-leave-active {
  animation: slide-out 100ms ease-out forwards;
}

@keyframes slide-in {
  from {
    /* transform: translateY(-120px) scale(0.1) rotate3d(25, 120, 60, 450deg); */
    opacity: 0;
  }
  to {
    /* transform: rotate(120, 90) rotate(0, 0, 0, -90deg); */
    opacity: 1;
  }
}
@keyframes slide-out {
  from {
    /* transform: translateY(0) scale(1); */
    opacity: 1;
  }
  to {
    /* transform: translateY(-120px) scale(0.1); */
    opacity: 0;
  }
}
</style>
